import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Suggest } from '@blueprintjs/select';
import { MenuItem, FormGroup, NumericInput, H3, H4, H6, Callout } from '@blueprintjs/core';
import { Paper } from '@material-ui/core';
import  Chart from 'react-apexcharts';

class Map extends React.PureComponent {

  state = {
    selectedDocId:"",
    windowSize:100,
    step:1,
    freqByWindow:[],
    height:350,
    freq:0,
    selectedItem:"",
  }


  setSelectedDocId=(doc_selectedDocId) => {
    const m1=doc_selectedDocId.match(/docId=(.*)/);
    if (!m1) {
      return;
    }
    const selectedDocId=m1[1];
    this.setState({selectedDocId:selectedDocId,selectedItem:doc_selectedDocId});
  }

  calcFreqByWindow = () => {
    const selectedDocId=this.state.selectedDocId;

    const sentNums=this.props.mapData[selectedDocId];
    if (! sentNums) {
      return [0,[]];
    }
    const freqByWindow=[];
    const m= selectedDocId.match(/#(\d+)#(\d+)$/);
    if (m[1] && m[2]) {
      const begin=parseInt(m[1]);
      const end=parseInt(m[2]);

      // initialization of inf / sup
      var inf=parseInt(sentNums[0]);
      var sup=Math.min(end,inf+this.state.windowSize);

      if (begin<inf-this.state.step) {
        freqByWindow.push([begin,0]);
      }
      const window=[];
      var i=0
      // initialization of windows : the list for docId that fall within inf and sup
      while(sentNums[i]<=sup && i<sentNums.length) {
        window.push(sentNums[i]);
        i++;
      }
      // si on est déjà arrivé au bout de l'intervalle pas besoin de faire le while
      var middle=Math.round((inf+sup)/2);
      var len=0;
      var lastLength=0;
      var lastMiddle=middle-this.state.step;
      // on encadre les valeurs pas des valeurs nulles
      
      if (i===sentNums.length) {
        freqByWindow.push([lastMiddle,lastLength]);
        freqByWindow.push([middle,window.length]);
      } else {
        while (sup<=end+this.state.step && i<=sentNums.length) {
          middle=Math.round((inf+sup)/2);
          len=window.length;
          
          // On ajoute la paire [middle,length] si length>0. 
          // On ajoute aussi des paires pour length===0 avant et après une longueur non nulle
          if (len>0) {
            if (lastLength===0) {
              freqByWindow.push([lastMiddle,lastLength]);
            } 
            freqByWindow.push([middle,len]);
          } else {
            if (lastLength>0){
              freqByWindow.push([middle,len]);
            }
          }
          
          
          // sliding window of 'step' sentences
          inf=inf+this.state.step;
          sup=sup+this.state.step;
          while (window && window[0]<inf){
            window.shift();
          }
          while(i<sentNums.length && parseInt(sentNums[i])<inf ) {
            i++;
          }
          while(i<sentNums.length &&  parseInt(sentNums[i])<=sup ) {
            window.push(sentNums[i]);
            i++
          }
          lastMiddle=middle;
          lastLength=len;
        }
      }
      freqByWindow.push([middle+this.state.step,0]);
    }
    return [sentNums.length,freqByWindow];
  }

  render() {
      const { t, estimatedResults, docMeta } = this.props;
      const [totFreq,data]=this.calcFreqByWindow();

      const items=Object.keys(docMeta).map( 
        docId => docMeta[docId]['corpusId']+" - "+ (docMeta[docId]['title']) +" - docId="+ docId
      ).sort( );
     
      const xyTab=[];

      if (data.length>2) {
        for (var x=0;x<data.length;x++) {
          const [coord,freq]=data[x];
         
          xyTab.push(
            { x: Math.round(coord),
              y: freq
            }
          );
        
        }
      }

      // prep data for the chart
      const series = [{
        name:t("freq"),
        data: xyTab
      }];
      const options = {
        
          chart: {
            type: 'line',
          },
          dataLabels: {
              enabled: false,
          },
          tooltip: {
            enabled:true,
            custom: ({series, seriesIndex, dataPointIndex, w}) =>  {

              const numSent=w.globals.initialSeries[0].data[dataPointIndex].x;
              const corpusId=this.props.docMeta[this.state.selectedDocId].corpusId;
            
              var lastNum=-1;
              var num=0;
              for (var i in this.props.concordsByCorpus[corpusId]) {
                if (this.props.concordsByCorpus[corpusId][i].docId===this.state.selectedDocId) {
                  num=parseInt(this.props.concordsByCorpus[corpusId][i].sentId.replace(/.*_(?=\d+$)/,""));
                  if ( lastNum <= numSent  && numSent <= num ) {
                    break;
                  }
                  lastNum=num;
                }
              }
            
              if ( lastNum!==-1 && Math.abs(numSent-lastNum) < Math.abs(num-numSent) ) {
                i--;
                num=lastNum;
              }
              const conc=this.props.concordsByCorpus[corpusId][i];

              return '<div class="arrow_box">' + num+
                ' : <span>' + [conc.left,conc.node,conc.right].join(" ") + '</span>' +
                '</div>'
            }
          },
          yaxis: {
              title: {
                  text: t("freq"),
              },
              labels: {
                  formatter: function (y) {
                    return y;
                  }
              }
          },
          xaxis: {
              type: 'numeric',
              labels: {
                  rotate: -90,
              },
          
          }
      };

      return (
       <>
          {
            estimatedResults &&
            <Callout intent="warning" >
              {t('textMapIsNotReliable')}
            </Callout>
            
          }


          <Paper className="margin-bottom-1-5-rem padding-1-rem">
            <H3>{t('selectADoc')}&nbsp;

              <Suggest 
                width={300}
                items={items} 
                selectedItem={this.state.selectedDocId} 
                itemPredicate={(query, doc, _index, exactMatch) => { 
                  const normalizedTitle = doc ? doc.toLowerCase():""; 
                  const normalizedQuery = query? query.toLowerCase():"";

                  if (exactMatch) { 
                      return normalizedTitle === normalizedQuery; 
                  } else { 
                      return normalizedTitle.includes(normalizedQuery) 
                  } 
                }} 
                itemRenderer={(item, itemProps) => { 
                    return ( 
                        <MenuItem 
                            key={item} 
                            value={item}
                            text={item} 
                            onClick={(e) => { 
                              this.setSelectedDocId(e.target.textContent); 
                            }} 
                            active={itemProps.modifiers.active} 
                        /> 
                    ); 
                }} 
                onItemSelect={() => { }} 
                tagRenderer={(item) => item} 
                inputValueRenderer={(item) => item.toString()} 
              />

            </H3>
          
            <H4>{this.state.selectedItem}</H4>
            <br/>
            <div>{t('mapExplanation')}</div>
            <br/>
            <FormGroup
              label={t('windowSize')}
              inline={true}
            >
              <NumericInput
                min={1} buttonPosition={null}
                value={this.state.windowSize}
                onValueChange={(newValue) => this.setState({windowSize:newValue})}
              />
            </FormGroup>

            <FormGroup
              label={t('step')}
              inline={true}
            >
              <NumericInput
                min={1} buttonPosition={null}
                value={this.state.step}
                onValueChange={(newValue) => this.setState({step:newValue})}
              />
            </FormGroup>

          { data.length>0 && 
            <div className="margin-bottom-1-rem">
              <p>{t('totFreqColon')} {totFreq}</p>
              <br/>
              <H6><u>{t('textMap')}</u></H6>
              <div>
                <Chart options={options} series={series} height={this.state.height}/> 
              </div>
            </div>
          }
        </Paper>

        
       </>
      );
  }
}


Map.propTypes = {
  subCorpora : PropTypes.array, // not used !
  mapData: PropTypes.object,
  docMeta: PropTypes.object,
  estimatedResults: PropTypes.bool,
  concordsByCorpus: PropTypes.object
};

export default withTranslation()(Map);
